import { useState, useEffect } from 'react';
import useSetQueryDefinition, { COND_PARAMS } from '@intelligence/hooks/useQueryDefinition';

export function useGenreMap() {
  const { condDatas, filterLoading } = useSetQueryDefinition({ ...COND_PARAMS.genreMap });
  const queryGenreMap = condDatas.genreMap;
  const [isLoading, setIsLoading] = useState(true);
  const [annieGenreMap, setAnnieGenreMap] = useState();
  const [ieggGenreMap, setIeggGenreMap] = useState();
  
  const transMap = (mapArr = []) => {
    const main: any = {};
    const sub: any = {};
    mapArr.forEach((item) => {
      const { main_genre: mainGenre = {}, sub_genre: subGenre = [] } = item || {};
      main[mainGenre?.genre?.toLowerCase()] = mainGenre;
      subGenre?.forEach((subItem: any) => {
        sub[subItem?.genre?.toLowerCase()] ={
          ...subItem,
          parentGenre: mainGenre?.genre,
        };
      });
    });
    return {
      main,
      sub,
    };
  };

  const getTransMap = (type: 'annir' | 'ieg') => {
    const genreMapCache = localStorage.getItem(`genreMap-${type}`);
    if (genreMapCache) return JSON.parse(genreMapCache);
    const transResult = transMap(queryGenreMap[type] || []);
    localStorage.setItem(`genreMap-${type}`, JSON.stringify(transResult));
    return transResult;
  };

  useEffect(() => {
    if (filterLoading) return;
    setIsLoading(true);
    if (queryGenreMap) {
      setIsLoading(false);
      setAnnieGenreMap(getTransMap('annir'));
      setIeggGenreMap(getTransMap('ieg'));
    }
  }, [queryGenreMap, filterLoading]);

  return {
    originalMap: queryGenreMap,
    annieGenreMap,
    ieggGenreMap,
    isLoading,
  };
}
